<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer :swiperList="swiperList"></Footer>
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      swiperList: [{
						img:  require('@/assets/img/banner_f001.jpg'),
						path: "",
						title: '',
						content: '',
					},
					{
						img: require('@/assets/img/banner_f002.jpg'),
						path: "",
						title: '',
						content: '- Sheraton Xiamen Hotel -',
					},
					{
						img: require('@/assets/img/banner_f003.jpg'),
						path: "",
						title: '',
						content: '- ',
					},
					{
						img: require('@/assets/img/banner_f004.jpg'),
						path: "",
						title: '',
						content: '',
					},
					{
						img: require('@/assets/img/banner_f005.jpg'),
						path: "",
						title: '',
						content: '',
					}
					,
					{
						img: require('@/assets/img/banner_f006.jpg'),
						path: "",
						title: '',
						content: '',
					}
					,
					{
						img: require('@/assets/img/banner_f007.jpg'),
						path: "",
						title: '',
						content: '',
					}
        // {
        //   img: require("@/assets/img/banner2.jpg"),
        //   path: "",
        //   title: '您身边的IT专家4',
        //   content: '宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介宣传简介',
        // }
      ]
    };
  }
}
</script>

<style>
  #app{
    width:100%;
  }
  .my-bullet {
    margin: 0 .02rem;
    width: 0.08rem;
    height: 0.08rem;
    display: inline-block;
    border-radius: 100%;
    background-color: rgba(255, 255, 255, 0.15);
  }
  .my-bullet-active{
    background-color:rgba(255, 255, 255, 0.6)
  }
  img{
    user-select: none;
  }
  @media screen and (max-width: 768px) {
    body{
      overflow-x:hidden;
    }
    .my-bullet {
      margin: 0 .09rem;
      width: 0.24rem;
      height: 0.24rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue